interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  const go = (page: number) => {
    if (page < 1 || page > total || page === current) return;
    onChange(page);
  };

  return (
    <nav
      aria-label="分页导航"
      className="flex items-center justify-center flex-wrap gap-2 mt-8"
    >
      <button
        type="button"
        onClick={() => go(current - 1)}
        disabled={current === 1}
        className="px-3 py-2 rounded-md text-sm border border-background-200 text-foreground-700 bg-background-50 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed enabled:hover:border-primary-400 enabled:hover:text-primary-600 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => go(page)}
          aria-current={page === current ? "page" : undefined}
          className={`w-10 h-10 flex items-center justify-center rounded-md text-sm font-medium border cursor-pointer ${
            page === current
              ? "bg-primary-500 border-primary-500 text-background-50 dark:text-foreground-950"
              : "bg-background-50 border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => go(current + 1)}
        disabled={current === total}
        className="px-3 py-2 rounded-md text-sm border border-background-200 text-foreground-700 bg-background-50 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed enabled:hover:border-primary-400 enabled:hover:text-primary-600 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}